import { api, buildApiUrl } from './axios';
import type {
  Invoice,
  InvoicePaymentHistoryResponse,
} from './types';

function parseDownloadFileName(
  contentDisposition?: string,
): string | null {
  if (!contentDisposition) {
    return null;
  }

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);

  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const asciiMatch = contentDisposition.match(/filename="?([^";]+)"?/i);

  return asciiMatch?.[1] ?? null;
}

export const getInvoice = (invoiceId: string) => {
  return api.get<Invoice>(`invoice/payer/${invoiceId}`);
};

export const getInvoicePayments = (invoiceId: string, page = 1) => {
  return api.get<InvoicePaymentHistoryResponse>(
    `invoice/payer/${invoiceId}/payments`,
    {
      params: { page },
    },
  );
};

export const createInvoiceStream = (invoiceId: string) => {
  return new EventSource(buildApiUrl(`invoice/payer/${invoiceId}/stream`));
};

export async function downloadInvoicePdf(invoiceId: string): Promise<{
  blob: Blob;
  fileName: string;
}> {
  const response = await api.get<Blob>(`invoice/payer/${invoiceId}/pdf`, {
    responseType: 'blob',
  });
  const fileName =
    parseDownloadFileName(response.headers['content-disposition']) ??
    `invoice-${invoiceId}.pdf`;

  return {
    blob: response.data,
    fileName,
  };
}
